/*
 * Action Types
 */
export enum GroupingModalTypes {
  SET_OPEN_MODAL = '@groupingModal/SET_OPEN_MODAL',
  SET_SELECTED_ITEMS = '@groupingModal/SET_SELECTED_ITEMS',
}

/*
 * Data types
 */

export interface GroupingModalOptionsInterface {
  key: string;
  value: string;
}

/*
 * State type
 */
export interface GroupingModalState {
  readonly openModal: boolean;
  readonly selectedItems: GroupingModalOptionsInterface[];
  readonly error: boolean;
  readonly loading: boolean;
}
